import(/* webpackMode: "eager" */ "/app/src/app/map/error.tsx")